import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ElementRef,
  HostListener,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIcon } from '@ng-icons/core';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';

@Component({
  selector: 'app-select-single',
  imports: [NgIcon, CommonModule, FormsModule],
  templateUrl: './select-single.component.html',
  styleUrls: ['./select-autocomplete.component.css'],
})
export class SelectSingleComponent implements OnInit, OnChanges {
  @Input() options: { label: string; value: any }[] = [];
  @Input() placeholder: string = 'Selecciona una opción';
  @Input() icon: string | null = null;
  @Input() addNewOption: boolean = false;
  @Input() type: 'text' | 'number' = 'text';

  @Output() select = new EventEmitter<any>();

  searchTerm: string = '';
  filteredOptions: { label: string; value: any }[] = [];
  isOpen: boolean = false;
  iconoSoles: string = APP_CONSTANTS.DEFAULT_ICON_SOLES;

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.filteredOptions = [{ label: 'Todos', value: null }, ...this.options];
    }
  }

  filterOptions() {
    const term = this.searchTerm.toLowerCase();
    this.filteredOptions = [
      { label: 'Todos', value: null },
      ...this.options.filter((option) =>
        option.label.toLowerCase().includes(term)
      ),
    ];
  }

  chooseOption(option: { label: string; value: any } | string) {
    if (typeof option === 'string') {
      this.searchTerm = option;
      this.select.emit(option);
    } else {
      this.searchTerm = option.label;
      this.select.emit(option.value);
    }
    this.isOpen = false;
  }

  handleInput(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (this.filteredOptions.length > 0) {
        this.chooseOption(this.filteredOptions[0]);
      } else if (this.addNewOption && this.searchTerm.trim() !== '') {
        this.chooseOption(this.searchTerm.trim());
      }
    }
  }

  get showAddOption(): boolean {
    const term = this.searchTerm.trim().toLowerCase();
    return (
      this.addNewOption &&
      term !== '' &&
      !this.options.some((o) => o.label.toLowerCase() === term)
    );
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
